<div class="content-container" role="main" aria-live="assertive">
  @if (theme.theme.mainTheme !== themeType.Custom) {
    <id-card>
      <ng-container *ngTemplateOutlet="mtlsNoCertificateContent"></ng-container>
    </id-card>
  } @else {
    <div class="custom-card">
      <ng-container *ngTemplateOutlet="mtlsNoCertificateContent"></ng-container>
    </div>
  }

  <ng-template #mtlsNoCertificateContent>
    <div class="flex flex-column flex-align-center">
      <img class="icon" src="assets/images/mtls-icon.svg" alt="SITHS eID ikon" />
      <h1 class="{{ theme.theme.mainTheme !== themeType.Custom ? 'ids-heading-xl' : 'custom-heading-xl' }} ids-mt-5">
        Inget certifikat användes
      </h1>
    </div>

    <div class="instructions-text-container ids-mt-5">
      <p class="instructions-text">
        Inget certifikat användes vid {{ getMethodTypeInstructionsText() }}. Var god sätt i ditt kort i din kortläsare
        och tryck sedan på Försök igen.
      </p>
    </div>

    <div class="ids-mt-5 flex flex-column align-center">
      <id-link>
        <a href="javascript:void(0);" (click)="retry()">Försök igen</a>
      </id-link>

      <id-link>
        <a href="javascript:void(0);" (click)="cancel()">Avbryt {{ getMethodTypeText() }}</a>
      </id-link>
    </div>
  </ng-template>
</div>
